import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { fontAccent, fontBody, fontTitle } from 'Styles/fonts';
import bp from 'Styles/breakpoints';
import readableText from 'Styles/readable-text';
import Layout from '../Layout/Layout';

export const Block = styled(Layout)`
  padding-top: ${({ paddingTop }) =>
    ifProp({ paddingTop: '' }, '32px', paddingTop)};
  padding-right: ${({ paddingRight }) =>
    ifProp({ paddingRight: '' }, '16px', paddingRight)};
  padding-bottom: ${({ paddingBottom }) =>
    ifProp({ paddingBottom: '' }, '32px', paddingBottom)};
  padding-left: ${({ paddingLeft }) =>
    ifProp({ paddingLeft: '' }, '16px', paddingLeft)};

  background-color: ${({ $backgroundColor }) => $backgroundColor};

  ${({ $styleQueryMode }) => css`
    ${bp('medium', { mode: $styleQueryMode })} {
      padding-top: ${({ paddingTop }) =>
        ifProp({ paddingTop: '' }, '48px', paddingTop)};
      padding-right: ${({ paddingRight }) =>
        ifProp({ paddingRight: '' }, '24px', paddingRight)};
      padding-bottom: ${({ paddingBottom }) =>
        ifProp({ paddingBottom: '' }, '48px', paddingBottom)};
      padding-left: ${({ paddingLeft }) =>
        ifProp({ paddingLeft: '' }, '24px', paddingLeft)};
    }

    ${bp('large', { mode: $styleQueryMode })} {
      padding-top: ${({ paddingTop }) =>
        ifProp({ paddingTop: '' }, '64px', paddingTop)};
      padding-bottom: ${({ paddingBottom }) =>
        ifProp({ paddingBottom: '' }, '64px', paddingBottom)};
    }
  `}
`;

/**
 * Basic layout helper for a 12 column grid
 */
export const Editorial = styled.div`
  width: 100%;
  height: auto;
  display: grid;
  grid-column: 1 / -1;
  grid-gap: 8px;
  align-items: ${({ $alignment }) => $alignment};
  ${({ $alignment }) => $alignment === 'center' && 'text-align: center;'};

  ${({ $styleQueryMode }) =>
    $styleQueryMode === 'screen' &&
    css`
      ${bp('medium')} {
        grid-column: 2 / span 10;
      }
      ${bp('large')} {
        grid-column: 3 / span 8;
      }
    `}
`;

export const Icon = styled.img`
  ${({ $alignment }) =>
    $alignment === 'center' &&
    'margin-left: auto; margin-right: auto; margin-top: 0;'};
  display: inline-block;
  height: 48px;

  ${({ $styleQueryMode }) => css`
    ${bp('large', { mode: $styleQueryMode })} {
      height: 64px;
    }
  `}
`;

export const RichText = styled.div`
  ${fontBody(18)}
  ${({ $backgroundColor }) => readableText($backgroundColor)}
  overflow-wrap: break-word;
  margin-bottom: 8px;

  ${({ $styleQueryMode }) => css`
    ${bp('medium', { mode: $styleQueryMode })} {
      margin-bottom: 4px;

      &:last-child {
        margin-bottom: 0px;
      }
    }
  `}

  & > h1 {
    ${fontTitle(40)}

    ${({ $styleQueryMode }) => css`
      ${bp('medium', { mode: $styleQueryMode })} {
        ${fontTitle(64)}
      }
    `}
  }

  & > h2 {
    ${fontAccent(24)}
    margin-bottom: 8px;

    ${({ $styleQueryMode }) => css`
      ${bp('medium', { mode: $styleQueryMode })} {
        ${fontAccent(32)}
      }

      ${bp('large', { mode: $styleQueryMode })} {
        ${fontAccent(40)}
      }
    `}
  }

  & > h3 {
    ${fontAccent(20)}
    margin-bottom: 4px;

    ${({ $styleQueryMode }) => css`
      ${bp('medium', { mode: $styleQueryMode })} {
        ${fontAccent(24)}
      }

      ${bp('large', { mode: $styleQueryMode })} {
        ${fontAccent(32)};
      }
    `}
  }

  & > h4 {
    ${fontAccent(16)}
    margin-bottom: 4px;
  }

  & > ul,
  & > ol,
  & > p {
    ${fontBody(16)}
    margin-bottom: 12px;

    ${({ $styleQueryMode }) => css`
      ${bp('large', { mode: $styleQueryMode })} {
        ${fontBody(18)}
      }
    `}
  }

  & > *:empty {
    display: none;
  }

  & > *:only-child,
  & > *:last-child {
    margin-bottom: 0;
  }

  & a {
    color: inherit;
  }

  & b {
    font-weight: 700;
  }

  & i {
    font-style: italic;
  }
`;
